<template>
    <div class="container-fluid" style="min-width: 800px;">
        <img :src="output">
        <!--Heading-->

        <div class="row">
            <div class="col-6 m-b-30">
                <h2 class="m-b-0">{{invoice.invoice_number}}</h2>
            </div>
            <div class="col-6 text-right">
                <div class="btn-group">
                    <button aria-expanded="false" aria-haspopup="true" class="btn waves-effect waves-light btn-outline-success dropdown-toggle" data-toggle="dropdown" type="button">
                        Action
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="javascript:void(0)">Export as PDF</a>
                        <a @click="printInvoice()" class="dropdown-item" href="javascript:void(0)">Print</a>
                        <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript:void(0)">Void</a>
                    </div>
                </div>
            </div>
        </div>

        <!--Quick Summary-->

        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3>
                            <span class="label label-cyan" v-if="invoice.status === 'DRAFT'">Draft</span>
                            <span class="label label-brown" v-if="invoice.status === 'VOID'">Void</span>
                            <span class="label label-primary" v-if="invoice.status === 'SENT'">Sent</span>
                            <span class="label label-warning" v-if="invoice.status === 'WRITE-OFF'">Write-Off</span>
                            <span class="label label-light-green" v-if="invoice.status === 'RECORD_PAYMENT'">Payment Recorded</span>
                            <span class="label label-dark-green" v-if="invoice.status === 'PAID'">Paid</span>
                        </h3>
                        <span>Status</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3 class="font-medium m-b-0" v-if="currentOrg.type === 'COOP'">{{invoice.buyer.biz_name}}</h3>
                        <h3 class="font-medium m-b-0" v-if="currentOrg.type === 'COOP_MEMBER'">{{invoice.seller.biz_name}}</h3>
                        <span v-if="currentOrg.type === 'COOP'">Buyer</span>
                        <span v-if="currentOrg.type === 'COOP_MEMBER'">Seller</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="d-flex align-items-center">
                    <div>
                        <h3 class="font-medium m-b-0" v-if="invoice.amount_due">{{invoice.amount_due | money}}</h3>
                        <span>Amount Due</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 text-right">
                <div class="ml-auto">
                    <div>
                        <h3 class="font-medium text-right m-b-0" v-if="invoice.due_at">{{ invoice.due_at|medium }}</h3>
                        <h3 class="font-medium text-right m-b-0" v-else>-</h3>
                        <span class="text-right">Due Date</span>
                    </div>
                </div>
            </div>
        </div>

        <!--Action Cards-->

        <div class="row m-t-20">
            <div class="col-lg-12 col-md-12">
                <div class="card" v-bind:class="{'card-highlighted': !isDraft(invoice)}">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <div class="step-badge">
                                    <div class="step-badge-inner" v-if="!isDraft(invoice)">1</div>
                                    <div class="step-badge-inner step-badge-inner-checked" v-if="isDraft(invoice)"><i class="fas fa-check"></i></div>
                                </div>
                            </div>
                            <div class="p-10">
                                <h3 class="text-muted">Create Invoice</h3>
                                <h6 class="text-dark">Created: {{invoice.created_at | long}}</h6>
                            </div>
                            <div class="ml-auto">
                                <div class="button-group">
                                    <button @click="edit()" class="btn waves-effect waves-light btn-outline-success" type="button"
                                            v-if="!isBuyer() && ['DRAFT','SENT','RECORD_PAYMENT'].includes(invoice.status)">Edit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-link"></div>
                <div class="card" v-bind:class="{'card-highlighted': !isSent(invoice)}">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <div class="step-badge">
                                    <div class="step-badge-inner" v-if="!isSent(invoice)">2</div>
                                    <div class="step-badge-inner step-badge-inner-checked" v-if="isSent(invoice)"><i class="fas fa-check"></i></div>
                                </div>
                            </div>
                            <div class="p-10">
                                <h3 class="text-muted">Send Invoice</h3>
                                <h6 class="text-dark">Last Sent: {{invoice.created_at | long}}</h6>
                            </div>
                            <div class="ml-auto">
                                <button @click="sendInvoice()" class="btn waves-effect waves-light btn-outline-success" type="button" v-if="isAdmin() && !isBuyer() &&  invoice.status=='DRAFT'">Send
                                </button>
                                <button @click="resendInvoice()" class="btn waves-effect waves-light btn-outline-success m-r-5" type="button"
                                        v-if="isAdmin() && !isBuyer() &&  ['SENT','RECORD_PAYMENT'].includes(invoice.status)">Resend
                                </button>
<!--                                <button @click="writeOff()" class="btn waves-effect waves-light btn-outline-success m-r-5" type="button"-->
<!--                                        v-if="isAdmin() && !isBuyer() && invoice.status==='SENT'">Write Off-->
<!--                                </button>-->
                                <button @click="_void()" class="btn waves-effect waves-light btn-outline-success" type="button"
                                        v-if="isAdmin() && !isBuyer() && invoice.status==='SENT'">Void
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-link"></div>
                <div class="card" v-bind:class="{'card-highlighted': !isPaid(invoice)}">
                    <div class="card-body">
                        <div class="d-flex no-block align-items-center">
                            <div>
                                <div class="step-badge">
                                    <div class="step-badge-inner" v-if="!isPaid(invoice)">3</div>
                                    <div class="step-badge-inner step-badge-inner-checked" v-if="isPaid(invoice)"><i class="fas fa-check"></i></div>
                                </div>
                            </div>
                            <div class="p-10">
                                <h3 class="text-muted">Payment</h3>
                                <h6 class="text-dark" v-if="invoice.amount_due">Amount Due: {{invoice.amount_due | money}}</h6>
                                <h6 class="text-dark" v-if="invoice.status !== 'PAID'">Status: Awaiting Payment</h6>
                                <h6 class="text-dark" v-if="invoice.status === 'PAID'">Status: Paid</h6>
                            </div>
                            <div class="ml-auto">
                                <button class="btn waves-effect waves-light btn-outline-success" data-target="#myModal" data-toggle="modal"
                                        type="button" v-if="!isBuyer() && ['SENT','RECORD_PAYMENT'].includes(invoice.status)">Record Payment
                                </button>
                                <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="myModal" role="dialog" tabindex="-1">
                                    <div class="modal-dialog">
                                        <div class="modal-content">
                                            <form @submit.prevent="handleSubmit">
                                                <div class="modal-header">
                                                    <h4 class="modal-title" id="myModalLabel">Record Payment</h4>
                                                    <button aria-hidden="true" class="close" data-dismiss="modal" type="button">×</button>
                                                </div>
                                                <div class="modal-body card-blue">
                                                    <div class="card-body">
                                                        <div class="form-group row">
                                                            <label class="col-sm-3 text-right control-label col-form-label" for="method">Payment Type</label>
                                                            <div class="col-sm-7">
                                                                <select :class="{'is-invalid': submitted && errors.has('method')}" class="custom-select mr-sm-2"
                                                                        data-vv-as="method"
                                                                        id="method"
                                                                        name="method"
                                                                        v-model="payment.method"
                                                                        v-validate="'required'">
                                                                    <option :value="null">Select Payment Method</option>
                                                                    <option value="BANK_TRANSFER">Bank Transfer</option>
                                                                    <option value="CHEQUE">Cheque</option>
                                                                </select>
                                                                <div class="invalid-feedback" v-if="submitted && errors.has('method')">{{ errors.first('method') }}</div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <label class="col-sm-3 text-right control-label col-form-label" for="amount">Amount</label>
                                                            <div class="col-sm-7">
                                                                <input :class="{'is-invalid': submitted && errors.has('amount')}" class="form-control"
                                                                       data-vv-as="amount"
                                                                       id="amount"
                                                                       name="amount"
                                                                       placeholder="Enter amount"
                                                                       step="any"
                                                                       type="number"
                                                                       v-model="payment.amount"
                                                                       v-validate="'required'">
                                                                <div class="invalid-feedback" v-if="submitted && errors.has('amount')">{{ errors.first('amount') }}</div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group row">
                                                            <label class="col-sm-3 text-right control-label col-form-label" for="currency">Currency</label>
                                                            <div class="col-sm-7">
                                                                <div :class="{'is-invalid': submitted && errors.has('currency')}" class="form-control p-0-0">
                                                                    <currency-select @currency-select="setCurrency" data-vv-as="currency"
                                                                                     id="currency"
                                                                                     name="currency"
                                                                                     ref="currency"
                                                                                     v-model="payment.currency_id"
                                                                                     v-validate="'required'">
                                                                    </currency-select>
                                                                </div>
                                                                <div class="invalid-feedback" v-if="submitted && errors.has('currency')">{{ errors.first('currency') }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="modal-footer">
                                                    <button class="btn waves-effect waves-light btn-success" type="submit">Submit</button>
                                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row hide">
            <div class="col-md-12">
                <div class="card card-shadow printableArea" id="printMe">
                    <div class="card-header border-bottom">
                        <div class="d-md-flex align-items-center m-t-20">
                            <div class="d-flex align-items-center">
                                <div>
                                    <h3 class="font-medium m-b-0">{{invoice.invoice_number}}</h3>
                                    <h6 class="text-muted m-t-5">Invoice Date {{invoice.created_at | date}}</h6>
                                    <h6 class="text-muted m-t-5">Due on {{invoice.due_at | date}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-blue card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Billed From</h5>
                                <h4 class="m-t-5">{{invoice.seller.biz_name}}</h4>
                                <p class="text-normal">
                                    {{invoice.seller.line1}}, &nbsp;{{invoice.seller.line2}}<br/>
                                    {{invoice.seller.country}},&nbsp;{{invoice.seller.city}}<br/>
                                    {{invoice.seller.state}},&nbsp;{{invoice.seller.postal_code}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.seller.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.seller.biz_email}}<br/>
                                    <span v-html="invoice.seller.description"></span>
                                </p>
                            </div>

                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">PO Information</h5>
                                <!--                                <h4 class="m-t-5">{{invoice.po||invoice.notes }}</h4>-->

                                <div class="row">
                                    <div class="col-sm-4 col-lg-3 font-weight-bold">P.O. #</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.po?invoice.po:'N/A' }}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">P.O. Date</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.po?invoice.created_at:'N/A' }}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">Due Date</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.due_at | medium}}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">Other Reference</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.notes}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row m-t-20">
                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Billed To</h5>
                                <h4 class="m-t-5">{{invoice.buyer.biz_name}}</h4>
                                <p class="text-normal">
                                    {{invoice.buyer.line1}}, &nbsp;{{invoice.buyer.line2}}<br/>
                                    {{invoice.buyer.country}},&nbsp;{{invoice.buyer.city}}<br/>
                                    {{invoice.buyer.state}},&nbsp;{{invoice.buyer.postal_code}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.buyer.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.buyer.biz_email}}<br/>
                                    <span v-html="invoice.buyer.description"></span>
                                </p>
                            </div>

                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Shipping Infromation</h5>
                                <h4 class="m-t-5">{{invoice.buyer.biz_name}}</h4>
                                <p class="text-normal" v-if="invoice.shipping_address">
                                    {{invoice.shipping_address.line1}}, &nbsp;{{invoice.shipping_address.line2}}<br/>
                                    {{invoice.shipping_address.country}},&nbsp;{{invoice.shipping_address.city}}<br/>
                                    {{invoice.shipping_address.state}},&nbsp;{{invoice.shipping_address.zip}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.buyer.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.buyer.biz_email}}
                                </p>
                                <p class="text-normal" v-else>
                                    {{invoice.buyer.line1}}, &nbsp;{{invoice.buyer.line2}}<br/>
                                    {{invoice.buyer.country}},&nbsp;{{invoice.buyer.city}}<br/>
                                    {{invoice.buyer.state}},&nbsp;{{invoice.buyer.postal_code}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.buyer.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.buyer.biz_email}}<br/>
                                    <span v-html="invoice.buyer.description"></span>
                                </p>
                            </div>
                        </div>

                        <div class="row m-t-40">
                            <div class="col-md-12">
                                <h5 class="font-bold text-muted">Items</h5>
                            </div>

                            <div class="col-md-12">
                                <div class="table-responsive" style="clear: both;">
                                    <table class="table table-bordered font-10" style="font-size: small;">
                                        <thead class="text-center">
                                        <tr>
                                            <th class="p-1 font-weight-bold" rowspan="2">#</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Name<br>(Code)</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Quantity</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Rate</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Total</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Discount</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Taxable Value</th>
                                            <th class="p-1 font-weight-bold" colspan="2">CGST</th>
                                            <th class="p-1 font-weight-bold" colspan="2">SGST</th>
                                            <th class="p-1 font-weight-bold" colspan="2">IGST</th>
                                        </tr>
                                        <tr>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(ini, index) in invoice.invoice_items">
                                            <td class="p-1">{{index + 1}}</td>
                                            <td class="p-1">{{ini.name}} - {{ini.variety}}<br>({{ini.code}})</td>
                                            <td class="p-1 text-right">{{ini.quantity | units}}</td>
                                            <td class="p-1 text-right">{{ini.amount.currency_symbol}}{{ini.rate}}/{{ini.quantity.unitSymbol}}</td>
                                            <td class="p-1 text-right" v-if="ini.amount">{{ini.amount | money}}</td>
                                            <td class="p-1 text-right">
                                                <template v-for="red in ini.reductions">{{red.amount | money}}<br></template>
                                            </td>
                                            <td class="p-1 text-right" v-if="getTaxableValue(ini)">{{getTaxableValue(ini) | money}}</td>
                                            <td class="p-1 text-right">
                                                {{ getCGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right" v-if="getTaxAmount(getTaxableValue(ini),getCGST(ini.taxes).rate)">
                                                {{ getTaxAmount(getTaxableValue(ini),getCGST(ini.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getSGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(ini),getSGST(ini.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getIGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(ini),getIGST(ini.taxes).rate) | money}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="p-1"></td>
                                            <td class="p-1" colspan="3">Freight Insurance Packing and Forwarding Charges</td>
                                            <td class="p-1 text-right" v-if="other.amount">{{other.amount | money}}</td>
                                            <td class="p-1 text-right">
                                                <template v-for="red in other.reductions">{{red.amount | money}}<br></template>
                                            </td>
                                            <td class="p-1 text-right">{{getTaxableValue(other) | money}}</td>
                                            <td class="p-1 text-right">
                                                {{ getCGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getCGST(other.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getSGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getSGST(other.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getIGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getIGST(other.taxes).rate) | money}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td colspan="2" class="p-1 text-right">Total</td>
                                            <td class="p-1 text-right">{{invoice.subtotal | money}}</td>
                                            <td class="p-1 text-right">{{invoice.discount | money}}</td>
                                            <td class="p-1 text-right">{{invoice.taxable_total | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.cgst | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.sgst | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.igst | money}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1 text-right">Total Invoice Value (In Figure)</td>
                                            <td colspan="6" class="p-1 text-right font-weight-bold" v-if="invoice.total">{{invoice.total | money}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1 text-right">Total Invoice Value (In Words)</td>
                                            <td colspan="6" class="p-1 text-right font-weight-bold">{{invoice.total.currency_symbol}} {{invoice.total.amount| unitFix(2) |words}} Only</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1">Amount of Tax subject to Reverse Charges</td>
                                            <td colspan="2"></td>
                                            <td colspan="2"></td>
                                            <td colspan="2"></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <p>We declare that the value mentioned in the Invoice is sole consideration for the supply , apart from the said amount , we have not received any other consideration
                                    in any other form for the said supply.</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-8">
                                <h5 class="font-bold text-muted">Payment Information</h5>
                                <div class="row">
                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Payment Terms</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.terms">: {{invoice.terms }}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-12 font-weight-bold"><u>Company Bank Details</u></div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Bank Name</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.bank}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Bank Address</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.address}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Account No</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.ac}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">IFSC Code</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.ifsc}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Swift Code</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.swift}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">MICR Code</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.micr}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>
                                </div>
                            </div>
                            <div class="col-sm-4 row">
                                <div class="col-12 border text-center h-50 position-absolute fixed-bottom">
                                    Office Use Only
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-shadow printableArea">
                    <div class="card-header border-bottom">
                        <div class="d-md-flex align-items-center m-t-20">
                            <div class="d-flex align-items-center">
                                <div>
                                    <h3 class="font-medium m-b-0">{{invoice.invoice_number}}</h3>
                                    <h6 class="text-muted m-t-5">Invoice Date {{invoice.created_at | date}}</h6>
                                    <h6 class="text-muted m-t-5">Due on {{invoice.due_at | date}}</h6>
                                    <h6  v-if="invoice.contract_ref" class="text-muted m-t-5">
                                        Contract <router-link :to="{name: 'view-marketplace-contract', params: {contractid: invoice.contract_ref}}">#{{invoice.contract_ref}}</router-link>
                                    </h6>
                                </div>
                            </div>
                            <div class="ml-auto">
<!--                                <router-link @click="edit" class="btn btn-default btn-outline" v-if="!isBuyer() && ['DRAFT','SENT','RECORD_PAYMENT'].includes(invoice.status)">-->
<!--                                    <span>-->
<!--                                        <i class="fas fa-pencil-alt"></i> Edit-->
<!--                                    </span>-->
<!--                                </router-link>-->
<!--                                <button @click="sendInvoice" class="btn btn-success btn-outline m-l-5" id="send" type="button" v-if="isAdmin() && !isBuyer() &&  invoice.status=='DRAFT'">-->
<!--                                    <span>-->
<!--                                        <i class="fas fa-paper-plane"></i> Send-->
<!--                                    </span>-->
<!--                                </button>-->
<!--                                <button @click="resendInvoice()" class="btn waves-effect waves-light btn-outline-success m-r-5" type="button"-->
<!--                                        v-if="isAdmin() && !isBuyer() &&  ['SENT','RECORD_PAYMENT'].includes(invoice.status)">-->
<!--                                    <span>-->
<!--                                        <i class="fas fa-paper-plane"></i> Resend-->
<!--                                    </span>-->
<!--                                </button>-->
                                <button @click="printInvoice" class="btn btn-secondary btn-outline m-l-5" id="print" type="button">
                                    <span>
                                        <i class="fa fa-print"></i> Print
                                    </span>
                                </button>
<!--                                <button class="btn btn-info btn-outline m-l-5" id="copy" type="button" v-if="invoice.status === 'DRAFT'">-->
<!--                                    <span>-->
<!--                                        <i class="fa fa-copy"></i> Copy-->
<!--                                    </span>-->
<!--                                </button>-->
                            </div>
                        </div>
                    </div>

                    <div class="card-blue card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Billed From</h5>
                                <h4 class="m-t-5">{{invoice.seller.biz_name}}</h4>
                                <p class="text-normal">
                                    {{invoice.seller.line1}}, &nbsp;{{invoice.seller.line2}}<br/>
                                    {{invoice.seller.country}},&nbsp;{{invoice.seller.city}}<br/>
                                    {{invoice.seller.state}},&nbsp;{{invoice.seller.postal_code}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.seller.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.seller.biz_email}}<br/>
                                    <span v-html="invoice.seller.description"></span>
                                </p>
                            </div>

                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">PO Information</h5>
                                <!--                                <h4 class="m-t-5">{{invoice.po||invoice.notes }}</h4>-->

                                <div class="row">
                                    <div class="col-sm-4 col-lg-3 font-weight-bold">P.O. #</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.po?invoice.po:'N/A' }}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">P.O. Date</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.po?invoice.created_at:'N/A' }}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">Due Date</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.due_at | medium}}</div>

                                    <div class="col-sm-4 col-lg-3 font-weight-bold">Other Reference</div>
                                    <div class="col-sm-8 col-lg-9">: {{invoice.notes}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="row m-t-20">
                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Billed To</h5>
                                <h4 class="m-t-5">{{invoice.buyer.biz_name}}</h4>
                                <p class="text-normal">
                                    {{invoice.buyer.line1}}, &nbsp;{{invoice.buyer.line2}}<br/>
                                    {{invoice.buyer.country}},&nbsp;{{invoice.buyer.city}}<br/>
                                    {{invoice.buyer.state}},&nbsp;{{invoice.buyer.postal_code}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.buyer.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.buyer.biz_email}}<br/>
                                    <span v-html="invoice.buyer.description"></span>
                                </p>
                            </div>

                            <div class="col-md-6">
                                <h5 class="font-bold text-muted">Shipping Infromation</h5>
                                <h4 class="m-t-5">{{invoice.buyer.biz_name}}</h4>
                                <p class="text-normal" v-if="invoice.shipping_address">
                                    {{invoice.shipping_address.line1}}, &nbsp;{{invoice.shipping_address.line2}}<br/>
                                    {{invoice.shipping_address.country}},&nbsp;{{invoice.shipping_address.city}}<br/>
                                    {{invoice.shipping_address.state}},&nbsp;{{invoice.shipping_address.zip}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.buyer.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.buyer.biz_email}}
                                </p>
                                <p class="text-normal" v-else>
                                    {{invoice.buyer.line1}}, &nbsp;{{invoice.buyer.line2}}<br/>
                                    {{invoice.buyer.country}},&nbsp;{{invoice.buyer.city}}<br/>
                                    {{invoice.buyer.state}},&nbsp;{{invoice.buyer.postal_code}}<br/>
                                    <i class="fas fa-phone"></i>&nbsp;{{invoice.buyer.biz_phone}}<br/>
                                    <i class="fas fa-envelope"></i>&nbsp;{{invoice.buyer.biz_email}}<br/>
                                    <span v-html="invoice.buyer.description"></span>
                                </p>
                            </div>
                        </div>

                        <div class="row m-t-40">
                            <div class="col-md-12">
                                <h5 class="font-bold text-muted">Items</h5>
                            </div>

                            <div class="col-md-12">
                                <div class="table-responsive" style="clear: both;">
                                    <table class="table table-bordered font-10" style="font-size: small;">
                                        <thead class="text-center">
                                        <tr>
                                            <th class="p-1 font-weight-bold" rowspan="2">#</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Name<br>(Code)</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Quantity</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Rate</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Total</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Discount</th>
                                            <th class="p-1 font-weight-bold" rowspan="2">Taxable Value</th>
                                            <th class="p-1 font-weight-bold" colspan="2">CGST</th>
                                            <th class="p-1 font-weight-bold" colspan="2">SGST</th>
                                            <th class="p-1 font-weight-bold" colspan="2">IGST</th>
                                        </tr>
                                        <tr>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                            <th class="p-1 font-weight-bold">Rate</th>
                                            <th class="p-1 font-weight-bold">Amount</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(ini, index) in invoice.invoice_items">
                                            <td class="p-1">{{index + 1}}</td>
                                            <td class="p-1">{{ini.name}} - {{ini.variety}}<br>({{ini.code}})</td>
                                            <td class="p-1 text-right">{{ini.quantity | units}}</td>
                                            <td class="p-1 text-right">{{ini.amount.currency_symbol}}{{ini.rate}}/{{ini.quantity.unitSymbol}}</td>
                                            <td class="p-1 text-right">{{ini.amount | money}}</td>
                                            <td class="p-1 text-right">
                                                <template v-for="red in ini.reductions">{{red.amount | money}}<br></template>
                                            </td>
                                            <td class="p-1 text-right">{{getTaxableValue(ini) | money}}</td>
                                            <td class="p-1 text-right">
                                                {{ getCGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(ini),getCGST(ini.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getSGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(ini),getSGST(ini.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getIGST(ini.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(ini),getIGST(ini.taxes).rate) | money}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="p-1"></td>
                                            <td class="p-1" colspan="3">Freight Insurance Packing and Forwarding Charges</td>
                                            <td class="p-1 text-right">{{other.amount | money}}</td>
                                            <td class="p-1 text-right">
                                                <template v-for="red in other.reductions">{{red.amount | money}}<br></template>
                                            </td>
                                            <td class="p-1 text-right">{{getTaxableValue(other) | money}}</td>
                                            <td class="p-1 text-right">
                                                {{ getCGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getCGST(other.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getSGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getSGST(other.taxes).rate) | money}}
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getIGST(other.taxes).rate | unitFix(2)}}%
                                            </td>
                                            <td class="p-1 text-right">
                                                {{ getTaxAmount(getTaxableValue(other),getIGST(other.taxes).rate) | money}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td colspan="2" class="p-1 text-right">Total</td>
                                            <td class="p-1 text-right">{{invoice.subtotal | money}}</td>
                                            <td class="p-1 text-right">{{invoice.discount | money}}</td>
                                            <td class="p-1 text-right">{{invoice.taxable_total | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.cgst | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.sgst | money}}</td>
                                            <td colspan="2" class="p-1 text-right">{{invoice.igst | money}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1 text-right">Total Invoice Value (In Figure)</td>
                                            <td colspan="6" class="p-1 text-right font-weight-bold">{{invoice.total | money}}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1 text-right">Total Invoice Value (In Words)</td>
                                            <td colspan="6" class="p-1 text-right font-weight-bold">{{invoice.total.currency_symbol}} {{invoice.total.amount| unitFix(2) |words}} Only</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td colspan="6" class="p-1">Amount of Tax subject to Reverse Charges</td>
                                            <td colspan="2"></td>
                                            <td colspan="2"></td>
                                            <td colspan="2"></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <p>We declare that the value mentioned in the Invoice is sole consideration for the supply , apart from the said amount , we have not received any other consideration
                                    in any other form for the said supply.</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-8">
                                <h5 class="font-bold text-muted">Payment Information</h5>
                                <!--                                <h4 class="m-t-5">{{invoice.seller.biz_name}}</h4>-->
                                <div class="row">
                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Payment Terms</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.terms">: {{invoice.terms }}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-12 font-weight-bold"><u>Company Bank Details</u></div>
                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Bank Name</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.bank}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Bank Address</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.address}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Account No</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.ac}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">IFSC Code</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.ifsc}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">Swift Code</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.swift}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>

                                    <div class="col-sm-3 col-lg-2 font-weight-bold">MICR Code</div>
                                    <div class="col-sm-9 col-lg-10" v-if="invoice.bank_account">: {{invoice.bank_account.micr}}</div>
                                    <div class="col-sm-9 col-lg-10" v-else>: NA</div>
                                </div>
                            </div>
                            <div class="col-sm-4 row">
                                <div class="col-12 border text-center h-50 position-absolute fixed-bottom">
                                    Office Use Only
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from '../../../common/Blockie';
    import CurrencySelect from '../../../common/CurrencySelect';
    import _ from "lodash";

    export default {
        name: "ViewInvoice",
        props: ["invoiceid"],
        components: {Blockie, CurrencySelect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                $BORLAUG: this.$BORLAUG,
                invoice: {
                    status: null,
                    contract_ref: null,
                    buyer: {
                        name: null,
                        biz_name: null,
                        biz_email: null,
                        biz_phone: null,
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        postal_code: null,
                        country: null,
                        country_code: null
                    },
                    seller: {
                        name: null,
                        biz_name: null,
                        biz_email: null,
                        biz_phone: null,
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        postal_code: null,
                        country: null,
                        country_code: null
                    },
                    shipping_address: {
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        zip: null,
                        country: null,
                        country_code: null
                    },
                    due_at: null,
                    total: {
                        amount: 0
                    },
                    bank_account: {},
                    taxable_total: {},
                    subtotal: {
                        amount: null
                    },
                    tax: null,
                    discount: {
                        amount: null
                    },
                    cgst: {
                        amount: null
                    },
                    sgst: {
                        amount: null
                    },
                    igst: {
                        amount: null
                    },
                    items: []
                },
                payment: {
                    method: null,
                    amount: null,
                    currency_id: null
                },
                other: {
                    "quantity": {},
                    "amount": {},
                    "taxes": [],
                    "reductions": []
                },
                orgImg: null,
                output: null
            };
        },
        mounted() {
            this.init();
            this.$root.$on('refreshInvoice', () => {
                this.init();
            })
        },
        methods: {
            async init() {
                await this.getInvoice();
                await this.getAttachment();
            },
            isAdmin() {
                return this.currentOrg && this.currentOrg.role === 'ORG_ADMIN';
            },
            isDraft(invoice) {
                return ['DRAFT', 'VOID', 'SENT', 'WRITE-OFF', 'RECORD_PAYMENT', 'PAID'].includes(invoice.status);
            },
            isSent(invoice) {
                return ['VOID', 'SENT', 'WRITE-OFF', 'RECORD_PAYMENT', 'PAID'].includes(invoice.status);
            },
            isPaid(invoice) {
                return invoice.status === 'PAID';
            },
            async getInvoice() {
                try {
                    $(".preloader").fadeIn();
                    let result   = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/invoices/${this.invoiceid}`);
                    $(".preloader").fadeOut();
                    this.invoice = result.data.invoice;
                    await this.calculateAmount();
                }catch (e) {
                    $(".preloader").fadeOut();
                }
            },
            async calculateAmount() {
                let subAmount      = _.sumBy(this.invoice.invoice_items, function(o) {
                    return o.amount.amount;
                });
                let taxAmount      = 0,
                    discountAmount = 0;

                this.invoice.cgst = {
                    amount: 0,
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.sgst = {
                    amount: 0,
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.igst = {
                    amount: 0,
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                _.forEach(this.invoice.invoice_items, ini => {
                    let tax = 0;

                    let rate = _.sumBy(ini.taxes, function(o) {
                        return o.tax.rate;
                    });

                    let discount = _.sumBy(ini.reductions, function(o) {
                        return o.amount.amount;
                    });

                    discountAmount = Number(discountAmount) + Number(discount);
                    let taxable    = Number(ini.rate) * Number(ini.quantity.amount) - discountAmount;

                    ini.taxes.forEach(t => {
                        if(t.name === 'CGST') {
                            this.invoice.cgst.amount += taxable * Number(t.rate) / 100;
                        } else if(t.name === 'SGST') {
                            this.invoice.sgst.amount += taxable * Number(t.rate) / 100;
                        } else if(t.name === 'IGST') {
                            this.invoice.igst.amount += taxable * Number(t.rate) / 100;
                        }

                        tax += taxable * Number(t.rate) / 100;
                    });

                    taxAmount = Number(taxAmount) + Number(tax);
                });

                this.invoice.tax = {
                    amount: taxAmount,
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.discount = {
                    amount: discountAmount,
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.subtotal = {
                    amount: Number(subAmount) - Number(discountAmount),
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.subtotal = {
                    amount: Number(subAmount),
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                this.invoice.taxable_total = {
                    amount: Number(subAmount) - Number(discountAmount),
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };

                let other = _.remove(this.invoice.invoice_items, {'name': 'OTHERS'});

                if(other.length > 0) {
                    this.other = other[0];
                }
            },
            async sendInvoice() {
                $(".preloader").fadeIn();
                try {
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/invoices/${this.invoiceid}/send`, {
                        comments: null
                    });
                    this.getInvoice();
                } catch(e) {
                    console.dir(e);
                    if(e.response.data.status === 500) {
                        this.$toastr('error', e.response.data.reason, 'Error!');
                    }
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async resendInvoice() {
                $(".preloader").fadeIn();
                await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/invoices/${this.invoiceid}/resend`, {
                    comments: null
                });
                $(".preloader").fadeOut();
                this.getInvoice();
            },
            async recordPayment() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/invoices/${this.invoiceid}/recordPayment`, this.payment);
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Payment recorded', 'Success');
                    this.getInvoice();
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                    this.$toastr('error', e.response.data.reason, 'Failed');
                }
            },
            viewSaleOrder(soid) {
                this.$router.push({name: "viewsale", params: {saleid: soid}});
            },
            edit() {
                this.$router.push({name: "editmarketplaceinvoice", params: {invoiceid: this.invoiceid}});
            },
            setCurrency(e) {
                if(e) {
                    this.payment.currency_id = e.id;
                }
            },
            async handleSubmit(e) {
                this.submitted = true;
                let valid      = await this.$validator.validate();
                if(valid) {
                    await this.recordPayment();
                    this.reset();
                    $('#myModal').modal('hide');
                }
            },
            reset() {
                this.submitted               = false;
                this.payment                 = {
                    method: null,
                    amount: null,
                    currency_id: null
                };
                this.$refs.currency.currency = null;
            },
            async getAttachment() {
                let attachments = await this.$http.get(`/org/${this.currentOrg.id}/attachments`);
                if(attachments.data && attachments.data.length > 0) {
                    this.orgImg = `https://attachments-acrecx.s3.us-east-2.amazonaws.com/${attachments.data[0].filepath}`;
                }
            },
            viewTx(tx) {
                console.log(tx);
            },
            viewContract(contract) {
                console.log(contract);
            },
            async writeOff() {
                if(this.invoice.status === 'SENT') {
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/invoices/${this.invoiceid}/writeoff`, {
                        comments: 'Money can\'t be collected'
                    });
                    this.getInvoice()
                }
            },
            async _void() {
                if(this.invoice.status === 'SENT') {
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/invoices/${this.invoiceid}/void`, {
                        comments: 'Invoice'
                    });
                    this.getInvoice()
                }
            },
            isBuyer() {
                return this.currentOrg.id === this.invoice.buyer_id;
            },
            getSubTotal(sale) {
                let amount      = sale.amount.amount;
                let taxes       = _.sumBy(sale.taxes, function(o) {
                    return o.tax.amount;
                });
                let adjustments = _.sumBy(sale.adjustments, function(o) {
                    return o.amount.amount;
                });

                amount = amount + taxes;
                amount = amount - adjustments;

                return {
                    amount: amount,
                    currency_id: this.invoice.total.currency_id,
                    currency_name: this.invoice.total.currency_name,
                    currency_symbol: this.invoice.total.currency_symbol
                };
            },
            printInvoice() {
                this.$htmlToPaper('printMe');
            },
            getTaxableValue(item) {
                let total = item.amount.amount;
                let reds  = _.sumBy(item.reductions, 'amount.amount');
                return {
                    ...item.amount,
                    amount: total - reds
                }
            },
            getCGST(taxes) {
                let tax = _.filter(taxes, {name: 'CGST'});
                return tax[0] || {rate: 0};
            },
            getSGST(taxes) {
                let tax = _.filter(taxes, {name: 'SGST'});
                return tax[0] || {rate: 0};
            },
            getIGST(taxes) {
                let tax = _.filter(taxes, {name: 'IGST'});
                return tax[0] || {rate: 0};
            },
            getTaxAmount(taxable, rate) {
                return {...taxable, amount: taxable.amount * rate / 100}
            },
        }
    }
</script>

<style scoped>
    .step-badge {
        color: #cdd1d3;
        float: left;
        font-size: 25px;
        line-height: 50px;
        margin-right: 18px;
        text-align: center;
        border-width: 2px;
    }

    .step-badge-inner {
        background: #fff;
        border: 2px solid #019b40;
        border-radius: 50%;
        color: #019b40;
        width: 50px;
        height: 50px;
        line-height: 46px;
        box-sizing: border-box;
    }

    .step-badge-inner-checked {
        color: #fff;
        background: #019b40;
        border-color: #019b40;
        line-height: 50px;
    }

    .b-t-0 {
        border-top: 0;
    }

    .b-b-0 {
        border-bottom: 0;
    }
</style>
